const initialState ={
  agentData:[],
  isSpinner:false
}

export default (state = initialState, action) => {
  switch (action.type) {
  case "SHOW_POP_UP_MESSAGE":
    return Object.assign({}, state, {      
      showPopUp: action.showPopUp,
      showPopUpmessage: action.showPopUpmessage
    })   
    case "SHOW_POP_UP_MESSAGE_FALSE":
    return Object.assign({}, state, {      
      showPopUp: action.showPopUp
    })
    case "SEARCH_CALIBARATION_SUCCESS":
    return Object.assign({}, state, {
      searchData: action.searchData,
      isPending: action.isPending
    })
    case "CALIBRATION_STATUS":
    return Object.assign({}, state, {
      calibrationStatus: action.calibrationStatus,
      isPending: action.isPending
    })
    case "SEARCH_CALIBARATION_QA_NAMES":
    return Object.assign({}, state, {
      QANameList: action.QANameList,
      isPending: action.isPending
    })
    case "SEARCH_CALIBARATION_QA_PENDING":
      return Object.assign({}, state, {
      isPending: action.isPending
    })
    case "AGENTS_LIST_SUCCESS":
      return Object.assign({}, state, {
        agentData: action.agentData
    })  
    case "SEARCH_CALIBARATION_PENDING":
      return Object.assign({}, state, {
      isPending: action.isPending
    })  
    case "WORKITEM_LISTING_ACTION_AGENT":
      return Object.assign({}, state, {
        agentbox: action.agentbox
    }) 
    case "WORKITEM_LISTING_ACTION_AUDITOR":
      return Object.assign({}, state, {
        auditorbox: action.auditorbox,
        isPending: action.isPending
    }) 
    case "WORKITEM_LISTING_ACTION_COUNT":
      return Object.assign({}, state, {
        count: action.count
    }) 
    case "WORKITEM_ERROR":  
      return Object.assign({}, state, {
      showerror: action.showerror,
      errmessage: action.errmessage,
      reassiged: action.reassiged,
      isPending: action.isPending,
      })
    case "RESET_ALL":
      return Object.assign({}, state, {
        reassiged: action.reassiged,
    })
    case "WORKITEM_MODAL_CLOSE":  
      return Object.assign({}, state, {
      showerror: action.showerror
    })
    case "WORK_ITEM_PENDING" :
      return Object.assign({}, state, {
        isPending: action.isPending
    })
    case "SEARCH_REASSIGN_SUCCESS":
      return Object.assign({}, state, {
        searchReAssignData: action.searchReAssignData,
        isPending: action.isPending
    })
    case "REASSIGNED":
      return Object.assign({}, state, {
        reassiged: action.reassiged
    })
    case "WORKITEM_COMPLETED_SCORES":
      return Object.assign({}, state, {
        ScoreCalculation: action.ScoreCalculation
    })
    case "SEARCH_REASSIGN_PENDING":
      return Object.assign({}, state, {
      isPending: action.isPending
    })
    case "SEARCH_RECORD_SUCCESS":
      return Object.assign({}, state, {
      searchRecord: action.searchRecord
    })
    case "WORKITEM_LISTING_ACTION_AGENT_COMPLETED":
      return Object.assign({}, state, {
      isPending: action.isPending,
      completedagent: action.completedagent
    })
    case "WORKITEM_LISTING_ACTION_AUDITOR_COMPLETED":
      return Object.assign({}, state, {
      isPending: action.isPending,
      completedauditor: action.completedauditor
    })
    case "SUBMIT_AUDITOR":
    return Object.assign({}, state, {
      submitted: action.submitted,
      isSpinner: action.isSpinner
    })
    case "ENABLE_SPINNER":
      return Object.assign({}, state, {
        isSpinner: action.isSpinner
      })
    case "SUBMIT_AUDITOR_RESET":
    return Object.assign({}, state, {
      submitted: action.submitted,
    })
    
    
    default:
      return state
  }
}